module.exports = __webpack_public_path__ + "static/media/lease.a2b4376c.svg";